<template>
  <v-container fluid class="pa-0 test" style="background-color:#fff">
    <v-card color="white" flat>
      <v-toolbar class="custom" color="white" elevation="0" fixed height="120">
        <v-toolbar-title class=" purple--text mr-2" style="overflow:show;">
          <v-img :src="require('../assets/logo.png')" width="70px"> </v-img>
        </v-toolbar-title>
        <v-toolbar-title
          class="font-weight-bold"
          style="font-size:1.3rem;bottom: -5px; position:relative;width:260px;"
        >
          SINAR FASTENER
          <div
            class="mt-0 primary--text"
            style="letter-spacing: 8px;font-weight: 400px;top: -7px; position:relative;"
          >
            INDONESIA
          </div>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-divider vertical inset></v-divider>
        <v-list three-line max-width="20%">
          <v-list-item>
            <v-list-item-icon>
              <v-icon color="#0081db">mdi-phone</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold mb-2">
                Kontak Kami
              </v-list-item-title>
              <v-list-item-subtitle>021-599-0860</v-list-item-subtitle>
              <v-list-item-subtitle>0878-7659-3469</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-list three-line max-width="27%" class="mr-10">
          <v-list-item>
            <v-list-item-icon>
              <v-icon color="#0081db">mdi-map-marker</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold mb-2">
                Kantor Kami
              </v-list-item-title>
              <v-list-item-subtitle
                >Perum Tigaraksa Blok AJ 47/10 Tangerang,
                Banten</v-list-item-subtitle
              >
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-btn
          color="#0081db"
          outlined
          tile
          class="font-weight-regular"
          to="/contact"
        >
          HUBUNGI KAMI
        </v-btn>
      </v-toolbar>
      <v-divider class="mx-auto" width="90%"></v-divider>
      <v-toolbar class="custom" color="white" elevation="0" height="80">
        <v-btn text tile color="#0081db" class="font-weight-bold" height="80">
          BERANDA
        </v-btn>
        <v-btn
          text
          tile
          v-scroll-to="{ el: '#service', offset: -80 }"
          class="font-weight-bold"
          height="80"
        >
          LAYANAN
        </v-btn>
        <v-btn
          text
          tile
          v-scroll-to="{ el: '#project', offset: -20 }"
          class="font-weight-bold"
          height="80"
        >
          PORTOFOLIO
        </v-btn>
        <v-btn text tile to="about" class="font-weight-bold" height="80">
          TENTANG
        </v-btn>
        <v-btn
          text
          tile
          class="font-weight-bold"
          to="/contact"
          height="80"
          v-scroll-to="{ el: '#element', offset: -30 }"
        >
          KONTAK
        </v-btn>
        <v-spacer />
        <v-icon @click="alert" color="black">
          mdi-magnify
        </v-icon>
      </v-toolbar>
      <v-carousel cycle height="590" hide-delimiters>
        <v-carousel-item v-for="(slide, i) in slides" :key="i">
          <v-sheet>
            <v-img :src="slide.src" width="100%" class="mx-auto" />
          </v-sheet>
        </v-carousel-item>
      </v-carousel>
    </v-card>
    <v-card
      class=" v-card--offset"
      color="rgba(34,34,34,.65)"
      width="520"
      height="300"
      elevation="5"
    >
      <v-row class="mx-1 mt-0">
        <v-col cols="12" md="12">
          <div class="tagline-margin">
            <h1 class="px-4 mb-5" v-text="item.subtitle"></h1>
            <div class="mx-5 my-5">
              <p class="text-left white--text">
                PT. Sinar Fastener Indonesia adalah perusahaan yang bergerak di
                bidang pengadaan barang konstruksi dan jasa kontraktor yang
                melayani perusahaan kecil, menengah dan perusahaan besar, baik
                swasta dan pemerintahan.
              </p>
            </div>
            <v-btn
              class="mx-5 font-weight-bold"
              color="#0081db"
              dark
              tile
              to="/contact"
            >
              HUBUNGI KAMI
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-card>
    <v-sheet
      class="mx-auto card-1"
      max-width="1200"
      color="white"
      min-height="500"
      max-height="700"
      elevation="0"
      id="scrolling-techniques-7"
    >
      <div class="mt-8" id="service">
        <p
          class="serviceText text-center display-1 font-weight-bold mt-1 mb-1 black--text"
        >
          LAYANAN KAMI
        </p>
        <p class="text-center heading-1 font-weight-reguler mb-10 grey--text">
          Pelayanan jasa konstruksi dan pengadaan barang dengan amanah dan
          komitmen serta dukungan dengan seluruh mitra perusahaan, dan penerapan
          manajemen teknologi efektif-efisien.
        </p>
      </div>
      <v-row class="px-12">
        <v-col
          v-for="(cat, i) in categories"
          :key="i"
          cols="6"
          md="4"
          class="categories"
        >
          <v-hover v-slot:default="{ hover }">
            <v-card
              class="mx-auto"
              max-width="400"
              tile
              color="white"
              elevation="0"
            >
              <v-list
                three-line
                max-height="180"
                min-height="160"
                :elevation="hover ? 12 : 0"
                :class="{ 'on-hover': hover }"
                :color="hover ? '#0081db' : '#f5f5f5'"
                :dark="hover ? true : false"
                class="pa-6"
              >
                <v-list-item three-line @click="services(cat)">
                  <v-list-item-icon>
                    <v-icon size="35" :color="hover ? 'white' : '#0081db'">
                      {{ cat.icon }}
                    </v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title
                      class="font-weight-bold mb-2"
                      style="letter-spacing:2px;"
                    >
                      {{ cat.title }}
                    </v-list-item-title>
                    <p
                      style="font-size:15px;"
                      :class="hover ? 'white--text' : 'grey--text'"
                    >
                      {{ cat.subtitle }}
                    </p>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card>
          </v-hover>
        </v-col>
      </v-row>
    </v-sheet>
    <!-- <v-toolbar
      width="75%"
      height="56px"
      class="mx-auto satisfation"
      elevation="0"
      shaped
    >
      <v-toolbar-title
        class="white--text mx-auto"
        style="font-size:15px"
        v-for="(item, i) in itemsToolbar"
        :key="i"
      >
        <v-icon dark>
          {{ item.icon }}
        </v-icon>
        {{ item.text }}
      </v-toolbar-title>
    </v-toolbar> -->

    <v-sheet
      class="mt-0 pt-8 project"
      max-width="100%"
      color="#f8f8f8"
      min-height="500"
      elevation="0"
    >
      <div id="project">
        <p class="text-center display-1 font-weight-bold my-1 black--text">
          PORTOFOLIO
        </p>
        <p class="text-center heading-1 font-weight-reguler mb-10 grey--text">
          Berikut galeri dari hasil projek pekerjaan yang sudah kami kerjakan
          beserta produk-produk yang kami berikan
        </p>
        <v-tabs background-color="#f8f8f8" centered color="#0081db">
          <v-tab>Semua</v-tab>
          <v-tab>Proyek</v-tab>
          <v-tab>Produk</v-tab>

          <v-tab-item class="bgcolor">
            <v-container color="#f8f8f8">
              <v-row>
                <v-col
                  v-for="n in projects"
                  :key="n.title"
                  class="d-flex child-flex"
                  cols="4"
                >
                  <v-hover v-slot:default="{ hover }">
                    <v-card flat tile class="d-flex" elevation="0">
                      <v-img
                        :src="n.img"
                        :lazy-src="n.img"
                        aspect-ratio="16:9"
                        class="grey lighten-2"
                      >
                        <v-expand-transition>
                          <div
                            v-if="hover"
                            class="d-flex transition-east-out darken-2 font-weight-bold v-card--reveal subheading white--text"
                            style="height: 100%;"
                          >
                            {{ n.title }}
                          </div>
                        </v-expand-transition>
                      </v-img>
                    </v-card>
                  </v-hover>
                </v-col>
                <v-btn
                  color="#0081db"
                  outlined
                  tile
                  class="font-weight-bold mx-auto mt-10"
                  to="projects"
                >
                  LIHAT SEMUA PROYEK DAN PRODUK
                </v-btn>
              </v-row>
            </v-container>
          </v-tab-item>
          <v-tab-item class="bgcolor">
            <v-container color="#f8f8f8">
              <v-row>
                <v-col
                  v-for="n in projectsProj"
                  :key="n.title"
                  class="d-flex child-flex"
                  cols="4"
                >
                  <v-hover v-slot:default="{ hover }">
                    <v-card flat tile class="d-flex" elevation="0">
                      <v-img
                        :src="n.img"
                        :lazy-src="n.img"
                        aspect-ratio="16:9"
                        class="grey lighten-2"
                      >
                        <v-expand-transition>
                          <div
                            v-if="hover"
                            class="d-flex transition-east-out darken-2 font-weight-bold v-card--reveal subheading white--text"
                            style="height: 100%;"
                          >
                            {{ n.title }}
                          </div>
                        </v-expand-transition>
                      </v-img>
                    </v-card>
                  </v-hover>
                </v-col>
              </v-row>
              <center>
                <v-btn
                  color="#0081db"
                  outlined
                  tile
                  class="font-weight-bold mx-auto mt-10"
                  to="projects"
                >
                  LIHAT SEMUA PROYEK DAN PRODUK
                </v-btn>
              </center>
            </v-container>
          </v-tab-item>
          <v-tab-item class="bgcolor">
            <v-container color="#f8f8f8">
              <v-row>
                <v-col
                  v-for="n in projectsProd"
                  :key="n.title"
                  class="d-flex child-flex"
                  cols="4"
                >
                  <v-hover v-slot:default="{ hover }">
                    <v-card flat tile class="d-flex" elevation="0">
                      <v-img
                        :src="n.img"
                        :lazy-src="n.img"
                        aspect-ratio="16:9"
                        class="grey lighten-2"
                      >
                        <v-expand-transition>
                          <div
                            v-if="hover"
                            class="d-flex transition-east-out darken-2 font-weight-bold v-card--reveal subheading white--text"
                            style="height: 100%;"
                          >
                            {{ n.title }}
                          </div>
                        </v-expand-transition>
                      </v-img>
                    </v-card>
                  </v-hover>
                </v-col>
                <v-btn
                  color="#0081db"
                  outlined
                  tile
                  class="font-weight-bold mx-auto mt-10"
                  to="projects"
                >
                  LIHAT SEMUA PROYEK DAN PRODUK
                </v-btn>
              </v-row>
            </v-container>
          </v-tab-item>
        </v-tabs>
      </div>
    </v-sheet>
    <v-sheet
      class="mt-10 project"
      max-width="100%"
      color="white"
      min-height="500"
      elevation="0"
    >
      <div id="about">
        <p class="text-center display-1 font-weight-bold my-1 black--text">
          MENGAPA MEMILIH KAMI
        </p>
      </div>
      <br />
      <br />
      <v-card width="90%" class="mx-auto" elevation="0">
        <v-row align="center" justify="center" class="text-center">
          <v-col cols="12" md="3" sm="6" class="text-center mr-0">
            <v-card height="315" elevation="0">
              <center>
                <v-icon class="mx-auto" size="85" color="#008db1">
                  mdi-account-multiple-check
                </v-icon>
              </center>
              <h4
                class="font-weight-bold mb-7 mt-5"
                style="font-size:18px;font-weight:600;font-family:lato,helveticaneue,helvetica neue,Helvetica,Arial,sans-serif"
              >
                Amanah
              </h4>
              <p style="color:#666">
                Kami menyediakan solusi bisnis yang jujur dan amanah kepada
                perusahaan yang menjadi mitra kami dimana hal yang menjadi
                keutamaan kami selalu mengutamakan kepuasan pelanggan serta
                kepercayaan demi kelangsungan bisnis yang harmonis dan
                berkelanjutan
              </p>
            </v-card>
          </v-col>
          <v-col cols="12" md="3" sm="6" class="text-center">
            <v-card height="315" elevation="0">
              <center>
                <v-icon class="mx-auto" size="85" color="#008db1">
                  mdi-check-decagram
                </v-icon>
              </center>
              <h4
                class="font-weight-bold mb-7 mt-5"
                style="font-size:18px;font-weight:600;font-family:lato,helveticaneue,helvetica neue,Helvetica,Arial,sans-serif"
              >
                Pelayanan Istimewa
              </h4>
              <p style="color:#666">
                Tujuan kami adalah untuk menjadi pilihan utama bagi mitra bisnis
                kami dengan memberikan kontribusi yang optimal kepada setiap
                klien kami sesuai yang diharapkan melalui pelayanan istimewa
                dari kami secara profesional dan integritas penuh
              </p>
            </v-card>
          </v-col>
          <v-col cols="12" md="3" sm="6" class="text-center">
            <v-card height="315" elevation="0">
              <center>
                <v-icon class="mx-auto" size="85" color="#008db1">
                  mdi-shield-check
                </v-icon>
              </center>
              <h4
                class="font-weight-bold mb-7 mt-5"
                style="font-size:18px;font-weight:600;font-family:lato,helveticaneue,helvetica neue,Helvetica,Arial,sans-serif"
              >
                Kualitas Terjamin
              </h4>
              <p style="color:#666">
                Keunggulan kami adalah memiliki lini lini sektor yang sudah kami
                dapat proses sendiri, sehingga menjadikan kualitas terjamin dan
                terpantau dari produk produk yang kami miliki.
              </p>
            </v-card>
          </v-col>
          <v-col cols="12" md="3" sm="6" class="text-center">
            <v-card height="315" elevation="0">
              <center>
                <v-icon class="mx-auto" size="85" color="#008db1">
                  mdi-tag-multiple
                </v-icon>
              </center>
              <h4
                class="font-weight-bold mb-7 mt-5"
                style="font-size:18px;font-weight:600;font-family:lato,helveticaneue,helvetica neue,Helvetica,Arial,sans-serif"
              >
                SUMBER DAYA TERBAIK
              </h4>
              <p style="color:#666">
                Kami optimis dengan memiliki sumber daya yang tinggi baik di
                sektor sumber daya manusia, sumber daya bahan baku, kami dapat
                menghasilkan kualitas pekerjaan dan pelayanan yang baik sesuai
                yang di harapkan mitra bisnis kami.
              </p>
            </v-card>
          </v-col>
          <v-btn
            color="#0081db"
            dark
            outlined
            tile
            class="font-weight-bold  mx-auto my-10"
            to="about"
          >
            LIHAT SELENGKAPNYA
          </v-btn>
        </v-row>
      </v-card>
    </v-sheet>
    <v-sheet
      class="mx-auto"
      max-width="900"
      style="top:-150px; position:relative;"
    >
      <div id="mitra">
        <p
          class="text-center display-1 font-weight-bold mt-1 mb-6 black--text"
          id="element"
        >
          MITRA KAMI
        </p>
        <v-divider class="mb-10 mx-auto" width="90%"></v-divider>
      </div>
      <v-slide-group v-model="model" center-active show-arrows>
        <v-slide-item
          v-for="n in mitra"
          :key="n.title"
          v-slot:default="{ active, toggle }"
        >
          <v-img
            :src="n.img"
            class="ma-2"
            max-height="100"
            max-width="250"
            width="250"
            @click="toggle"
            style="cursor:pointer"
          >
            <v-row class="fill-height" align="center" justify="center">
              <v-scale-transition>
                <v-card
                  v-if="active"
                  :color="active ? 'primary' : 'grey lighten-1'"
                  height="100"
                  width="250"
                >
                  <v-card-text class="text-center white--text mt-3">
                    {{ n.title }}
                  </v-card-text>
                </v-card>
              </v-scale-transition>
            </v-row>
          </v-img>
        </v-slide-item>
      </v-slide-group>
    </v-sheet>
    <v-footer padless>
      <v-card flat tile class="text-center pt-10" color="black">
        <v-row class="text-left custom-margin-footer">
          <v-col cols="4">
            <v-card-text>
              <h2 class="white--text">TENTANG</h2>
              <p class="darken-4 grey--text mt-3">
                PT. Sinar Fastener Indonesia adalah perusahaan yang bergerak di
                bidang pengadaan barang konstruksi dan jasa kontraktor yang
                melayani perusahaan kecil, menengah dan perusahaan besar, baik
                swasta dan pemerintahan dengan diawali dengan berdirinya usaha
                CV. Sinar Galvanis Metal sejak tahun 2002. Kami menyediakan
                solusi bisnis yang jujur dan amanah kepada perusahaan yang
                menjadi mitra kami dimana hal yang menjadi keutamaan kami selalu
                mengutamakan kepuasan pelanggan serta kepercayaan demi
                kelangsungan bisnis yang harmonis dan berkelanjutan
              </p>
            </v-card-text>
          </v-col>
          <v-col cols="4">
            <v-card-text>
              <h2 class="white--text">HELPFUL LINKS</h2>
              <ul class="darken-4 grey--text mt-3">
                <li class="mb-3">
                  <h3>
                    <a
                      href="/#/services"
                      class="blue--text"
                      style="text-decoration: none"
                      >Layanan</a
                    >
                  </h3>
                </li>
                <li class="mb-3">
                  <h3>
                    <a
                      href="/#/projects"
                      class="blue--text"
                      style="text-decoration: none"
                      >PROYEK DAN PRODUK</a
                    >
                  </h3>
                </li>
                <li class="mb-3">
                  <h3>
                    <a
                      href="/#/about"
                      class="blue--text"
                      style="text-decoration: none"
                      >Tentang</a
                    >
                  </h3>
                </li>
                <li>
                  <h3>
                    <a
                      href="/#/contact"
                      class="blue--text"
                      style="text-decoration: none"
                      >Kontak</a
                    >
                  </h3>
                </li>
              </ul>
            </v-card-text>
          </v-col>
          <v-col cols="4">
            <v-card-text>
              <h2 class="white--text">CONTACT US</h2>
              <p class="mt-3 darken-2 grey--text">
                Perum Tigaraksa BLOK AJ 47/10, Kel. Margasari, Kec. Tigaraksa,
                Kab. Tangerang, Prov. Banten
              </p>
              <p class="mt-3 darken-2 grey--text">
                Phone:
                <span class="white--text"> 021-599-0860 / 0878-7659-3469</span>
              </p>
              <p class="mt-3 darken-2 grey--text">
                Email:
                <a
                  href="mailto:marketing@sinarfastenerindonesia.com"
                  class="white--text"
                >
                  marketing@sinarfastenerindonesia.com
                </a>
              </p>
            </v-card-text>
          </v-col>
        </v-row>
        <v-divider color="grey"></v-divider>
        <v-card-text>
          <v-btn
            v-for="icon in iconsFooter"
            :key="icon"
            class="mx-4 blue--text"
            icon
          >
            <v-icon size="24px">{{ icon }}</v-icon>
          </v-btn>
        </v-card-text>
        <div>
          <v-divider color="grey"></v-divider>
          <v-card-text class="darken-4 grey--text">
            © Copyright 2020 by
            <a
              href="#"
              class="blue--text font-weight-bold"
              style="text-decoration: none"
              >Sinar Fastener</a
            >. All Rights Reserved.
          </v-card-text>
        </div>
      </v-card>
    </v-footer>
    <!-- <v-parallax
      dark
      src="https://cdn.vuetifyjs.com/images/backgrounds/vbanner.jpg"
    >
      <v-row
        align="center"
        justify="center"
      >
        <v-col class="text-center" cols="12">
          <h1 class="display-1 font-weight-thin mb-4">Vuetify.js</h1>
          <h4 class="subheading">Build your application today!</h4>
        </v-col>
      </v-row>
    </v-parallax> -->
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      colors: ["#582960", "#341992"],
      icons: ["mdi-rewind"],
      model: null,
      iconsFooter: [
        "mdi-facebook",
        "mdi-twitter",
        "mdi-google-plus",
        "mdi-linkedin",
        "mdi-instagram",
      ],
      itemProject: [
        { title: "Click Me" },
        { title: "Click Me" },
        { title: "Click Me" },
        { title: "Click Me 2" },
      ],
      itemServices: [
        { title: "Repair" },
        { title: "Painting" },
        { title: "Carpentry" },
        { title: "Plumbing" },
        { title: "Remodeling" },
        { title: "Electrical" },
      ],
      mitra: [
        {
          title: "PT. BUKAKA TEKNIK UTAMA",
          img: require("@/assets/bukaka.jpg"),
        },
        {
          title: "PT. WASKITA KARYA",
          img: require("@/assets/waskita.jpg"),
        },
        {
          title: "PT. CIPTA DIMENSI BAJA NUSATARA",
          img: require("@/assets/cipta-dimensi.jpg"),
        },
        {
          title: "PT. PRIMATAMA KONSTRUKSI",
          img: require("@/assets/primatama.jpg"),
        },
        {
          title: "PT. WAAGNER BIRO INDONESIA",
          img: require("@/assets/waagner.png"),
        },
        {
          title: "PT. KARUNIA BERCA INDONESIA",
          img: require("@/assets/karunia.jpg"),
        },
        {
          title: "PT. GALVINDO INTI SELARAS",
          img: require("@/assets/galvindo.png"),
        },
      ],
      projects: [
        {
          title: "PROYEK SMP IT RUHUL JADID",
          img: require("@/assets/projects/project-1.png"),
        },
        {
          title: "PROYEK JALAN TOL SUMEDANG",
          img: require("@/assets/projects/project-2.png"),
        },
        {
          title: "PROYEK JALAN TOL BOCIMI",
          img: require("@/assets/projects/project-3.png"),
        },
        {
          title: "BOLD AND NUT",
          img: require("@/assets/projects/bold-nut.png"),
        },
        {
          title: "ANCHOR - FIX",
          img: require("@/assets/projects/anchor-fix.png"),
        },
        {
          title: "ANCHOR - MOVE",
          img: require("@/assets/projects/anchor-move.png"),
        },
      ],
      projectsProj: [
        {
          title: "PROYEK SMP IT RUHUL JADID",
          img: require("@/assets/projects/project-1.png"),
        },
        {
          title: "PROYEK JALAN TOL SUMEDANG",
          img: require("@/assets/projects/project-2.png"),
        },
        {
          title: "PROYEK JALAN TOL BOCIMI",
          img: require("@/assets/projects/project-3.png"),
        },
        {
          title: "PROYEK SEKOLAH AZ-ZAHRA",
          img: require("@/assets/projects/project-4.png"),
        },
      ],
      projectsProd: [
        {
          title: "ANCHOR - FIX",
          img: require("@/assets/projects/anchor-fix.png"),
        },
        {
          title: "ANCHOR - MOVE",
          img: require("@/assets/projects/anchor-move.png"),
        },
        {
          title: "PRODUCT",
          img: require("@/assets/projects/product.png"),
        },
        {
          title: "THE ROD",
          img: require("@/assets/projects/rod.png"),
        },
        {
          title: "THE ROD 2",
          img: require("@/assets/projects/rod-2.png"),
        },
        {
          title: "BOLD AND NUT",
          img: require("@/assets/projects/bold-nut.png"),
        },
      ],
      transparent: "rgba(255, 255, 255, 0)",
      itemsToolbar: [
        { icon: "mdi-truck-delivery", text: "Responsive Maintenance" },
        { icon: "mdi-account-multiple-check", text: "Trusted Staff" },
        { icon: "mdi-check-decagram", text: "100% Guarantee" },
        { icon: "mdi-shield-check", text: "Protected Payment" },
        { icon: "mdi-tag-multiple", text: "Low Cost" },
      ],
      first: "John",
      last: "Doe",
      slides: [
        { src: require("@/assets/images-1.jpg") },
        { src: require("@/assets/images-4.jpg") },
        { src: require("@/assets/images-5.jpg") },
        { src: require("@/assets/images-2.jpg") },
        { src: require("@/assets/images-3.jpg") },
      ],
      categories: [
        {
          icon: "mdi-math-compass",
          title: "Konstruksi",
          subtitle:
            "Kami Menyediakan Jasa Konstruksi kerangka besi baja dan baja ringan.",
          to: "services",
        },
        {
          icon: "mdi-shovel",
          title: "Pembangunan",
          to: "services",
          subtitle:
            "Pembangunan untuk kantor, rumah tinggal, ruko, pabrik atau gudang.",
        },
        {
          icon: "mdi-format-paint",
          title: "Interior Design",
          to: "services",
          subtitle:
            "Menyediakan Interior Ruang pertemuan, direksi, kerja, resepsionis, ruang keluarga, kamar,counter bar dll.",
        },
        {
          icon: "mdi-box-shadow",
          title: "Baja dan Besi",
          to: "services",
          subtitle:
            " Kami menyediakan pengadaan untuk Baja ringan , Besi Kanal CNP, UNP , Reng, Anchor nut , Bolt Nut, Custome Anchor, Custome Nut.",
        },
        {
          icon: "mdi-shield-plus",
          title: "Peralatan Keamanan",
          to: "services",
          subtitle: "Kami menyediakan pengadaan untuk peralatan keamanan.",
        },
        {
          icon: "mdi-monitor-multiple",
          to: "services",
          title: "Komputer",
          subtitle:
            "Kami menyediakan pengadaan Komputer, laptop dan printer untuk kebutuhan anda.",
        },
      ],
      // logo: base
      item: {
        title: "Halo, Justiperz!",
        subtitle: "PERUSAHAAN KONSTRUKSI",
      },
      learn_more_img: require("@/assets/shopping.png"),
    };
  },
  methods: {
    alert() {
      alert("haii");
    },
    services(cat) {
      this.$router.push(`/${cat.to}`);
    },
  },
};
</script>

<style scoped>
.v-card--offset {
  opacity: 0.9;
  top: -450px;
  z-index: 5;
  left: 205px;
  border-top: 5px solid #0081db;
  color: white;
  position: relative;
}
.tagline-margin {
  margin-top: 30px;
}
.chat {
  top: -230px;
  position: relative;
  z-index: 1;
}
.custom {
  margin-inline-start: 170px;
  margin-inline-end: 170px;
}
.custom-margin-footer {
  margin-inline-start: 120px;
  margin-inline-end: 120px;
}
.customProject {
  margin-inline-start: 30%;
}
.categories.hover-image {
  background-color: blue;
}
.outline {
  border: 1.5px solid purple;
}
.v-card--reveal {
  align-items: center;
  bottom: 0;
  background-color: #0081db;
  justify-content: center;
  opacity: 0.9;
  z-index: 99;
  position: absolute;
  width: 100%;
}
.serviceText {
  border: 1px blue;
}
.v-img--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: 0.8;
  position: absolute;
  width: 100%;
}
.margin-auto {
  margin: auto;
}
.hover-image {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}
.card-1 {
  top: -240px;
  position: relative;
}
.satisfation {
  background: -webkit-gradient(
    linear,
    left top,
    right top,
    from(#3762d9),
    color-stop(35%, #6f66be),
    to(#8c00ff)
  );
  /* background : -webkit-gradient(linear,left top,right top,from(#e100ff),color-stop(35%,#bc64d6),to(#9e37d9)); */
  border-radius: 10px;
  top: -200px;
  position: relative;
}
.project {
  top: -150px;
  position: relative;
}
.v-card-custom {
  transition: opacity 0.4s ease-in-out;
}

.v-card-custom:not(.on-hover) {
  opacity: 0.6;
}
.v-window__container {
  background-color: #f8f8f8;
}
.show-btns {
  color: rgba(255, 255, 255, 1) !important;
}
.garis {
  border: 3px solid navy;
}
.footer-padding {
  padding-inline-start: 200px;
  padding-inline-end: 200px;
}
.test {
  border-top: blue;
}
</style>
